import { Button } from "../ui/button";
import { ComplexityChip, StatusChip, TouchAge } from "./ShelfChips";
import { CalendarDays, Undo2 } from "lucide-react";

const NEXT_ACTIONS = {
  claimed: [
    { status: "in_prep", label: "Start work" },
    { status: "complete", label: "Finished", variant: "secondary" },
  ],
  in_prep: [{ status: "complete", label: "Finished" }],
};

export const MyWorkCard = ({ item, busy, onStatus, onRelease, onOpen }) => {
  const actions = NEXT_ACTIONS[item.status] || [];
  const canRelease = ["claimed", "in_prep"].includes(item.status);
  const stale = item.hours_since_touched >= 72;
  const warm = item.hours_since_touched >= 48 && !stale;

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={() => onOpen(item)}
      onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onOpen(item)}
      className={`flex flex-col gap-3 p-5 bg-card border rounded-xl shadow-sm cursor-pointer hover:border-primary/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50 transition-colors duration-200 ${
        stale ? "border-rose-500/50" : warm ? "border-amber-500/50" : "border-border"
      }`}
      data-testid={`my-work-card-${item.id}`}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <h3 className="text-base font-semibold text-foreground tracking-tight leading-snug break-words">
            {item.client_id && (
              <span className="font-mono text-muted-foreground mr-2">{item.client_id}</span>
            )}
            {item.client_name}
          </h3>
          <p className="text-xs text-muted-foreground mt-0.5 font-mono">
            {item.work_label}
          </p>
        </div>
        <div className="flex flex-col items-end gap-1.5">
          <StatusChip value={item.status} />
          <ComplexityChip value={item.complexity} />
        </div>
      </div>

      <div className="flex items-center gap-3 flex-wrap">
        <TouchAge hours={item.hours_since_touched} />
        {item.due_date && (
          <span className="flex items-center gap-1.5 text-xs text-muted-foreground">
            <CalendarDays size={12} /> Due {item.due_date}
          </span>
        )}
      </div>

      <div className="flex flex-wrap gap-2 mt-auto">
        {actions.map((a) => (
          <Button
            key={a.status}
            size="sm"
            variant={a.variant}
            disabled={busy}
            onClick={(e) => {
              e.stopPropagation();
              onStatus(item, a.status);
            }}
            data-testid={`status-btn-${a.status}-${item.id}`}
          >
            {a.label}
          </Button>
        ))}
        {canRelease && (
          <Button
            size="sm"
            variant="ghost"
            className="gap-1.5 text-muted-foreground"
            disabled={busy}
            onClick={(e) => {
              e.stopPropagation();
              onRelease(item);
            }}
            data-testid={`release-btn-${item.id}`}
          >
            <Undo2 size={13} /> Hand back
          </Button>
        )}
      </div>
    </div>
  );
};
